import { Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { NxTemplateDirective } from '../../directives/nx-template.directive';

@Component({
    selector: 'nx-table-header',
    template: `
    <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="basis-1/3 flex flex-row items-center ml-3 font-medium">
            {{ label | translate }}
        </div>
        <div class="basis-1/3 flex flex-row justify-center items-center">
            <ng-template *ngTemplateOutlet="middleTemplate"></ng-template>
        </div>
        <div class="basis-1/3 flex flex-row justify-end items-center mr-3">
            <ng-template *ngTemplateOutlet="endTemplate"></ng-template>
        </div>
    </div>
  `
})
export class TableHeaderComponent {

    @Input() label: string;

    /**
   * All templates that are inside the box tag in the parent component
   */
    @ContentChildren(NxTemplateDirective) templates!: QueryList<NxTemplateDirective>;

    /**
    * The template for the label of the box
    */
    public middleTemplate: TemplateRef<any> | undefined;

    /**
     * The template for the label of the box
     */
    public endTemplate: TemplateRef<any> | undefined;

    constructor(
    ) {
    }

    /**
   * Walks through all templates and assigns them to the corresponding variables
   */
    ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'middle':
                    this.middleTemplate = item.template;
                    break;
                case 'end':
                    this.endTemplate = item.template;
                    break;
            }
        });
    }


}